 
import { useMemo, useRef, useState } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";
 
import { FormInstance } from "antd";
import ModalPopup from "../Components/ModalPopup/ModalPopup";
import InterfaceComponent from "./Masters/InterfaceComponent";
import { API } from "../Axios/Axios";

export default function SamplePage() {
  const formRef = useRef<FormInstance>(null);
  const [isQuickAddModalVisible, setIsQuickAddModalVisible] = useState({});
  const reportActionHandler = {
    checkIfValidationOK: async (actionType: string, ...params: any[]) => {
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    Query: async (...params: any[]) => {
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    CheckReportActionFunction: async (actionType: string, ...params: any[]) => {
      console.log("CheckReportActionFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    viewClick: (...params: any[]) => {
      if (params[1].Title.includes("Har")) {
        return false;
      }
      return true;
    },
  };

  const openModalKey = useMemo(() => {
    return Object.keys(isQuickAddModalVisible).find(
      (key) => isQuickAddModalVisible[key]
    );
  }, [isQuickAddModalVisible]);

  const interfaceActionHandler = {
    handleFileSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      const formData = params[0];
      const formDataToSend = new FormData();

      formData?.profile_picture1?.forEach((file: any) => {
        formDataToSend.append("File", file.originFileObj as File);
      });

      formDataToSend.append("Overwrite", "true");
      formDataToSend.append("Container", "Demo");

      const postRes = await API.post("/Documents/upload", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Normalized structure
      const uploadedFiles =
        formData?.profile_picture1?.map((file: any) => ({
          name: postRes?.data?.data?.name ?? file.name,
          path: postRes?.data?.data?.documentUrl,
          id: postRes?.data?.data?.documentId,
        })) ?? [];

      // Update form value
      formRef.current!.setValue("profile_picture1", uploadedFiles);

      return {
        data: {
          status: 0,
          message: "OK",
          data: [
            {
              key: "profile_picture1",
              value: uploadedFiles, // full array instead of just paths
              Id: 0,
              IsActive: false,
            },
          ],
        },
      };
    },

    // Update existing + new files
    handleFileUpdate: async (actionType: string, ...params: any[]) => {
      const profile_picture1 = params[0]?.profile_picture1 ?? [];

      const normalizedFiles: any[] = [];

      for (const file of profile_picture1) {
        // Already uploaded file
        if (file.url && !file.originFileObj) {
          normalizedFiles.push({
            name: file.name ?? file.url.split("/").pop(),
            path: file.url.startsWith("/") ? file.url.substring(1) : file.url,
            id: file.id ? String(file.id) : "",
          });
        }
        // New file -> upload via API
        else if (file.originFileObj) {
          const formData = new FormData();
          formData.append("File", file.originFileObj);
          formData.append("overwrite", "true");
          formData.append("container", "Demo");

          try {
            const response = await API.post("/Documents/upload", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            const uploadedPath = response?.data?.data?.documentUrl ?? "";
            const uploadedId = response?.data?.data?.documentId ?? "";
            const uploadedName = response?.data?.data?.name ?? file.name;

            normalizedFiles.push({
              name: uploadedName,
              path: uploadedPath,
              id: String(uploadedId),
            });
          } catch (err) {
            console.error("Upload failed:", err);
          }
        }
      }

      // Update form value
      formRef.current!.setValue("profile_picture1", normalizedFiles);

      return {
        data: {
          status: 0,
          message: "OK",
          data: [
            {
              key: "profile_picture1",
              value: normalizedFiles,
            },
          ],
        },
      };
    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
       
    },
    Query: async (...params: any[]) => {
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    closeModal: async (button: any, form: any) => {

      if (openModalKey) {
        
        formRef.current!.setValue(openModalKey, form[openModalKey]);
        setIsQuickAddModalVisible((prev) => ({
          ...prev,
          [openModalKey]: false,
        }));
      }
    },
  };

   
  const interfaceFieldActionHandler = {
    HandleRoleOnChange: async (form: any) => {
      let values: Record<string, any>;
      if ("getFieldsValue" in form) {
        values = form.getFieldsValue();
      } else {
        values = form;
      }
       
      if (values["favorite_color1"] === "1") {
        await formRef.current!.hideField("color1_code");
      } else {
        await formRef.current!.showField("color1_code");
      }
      if (values["favorite_color1"] === "2") {
        await formRef.current!.hideField("State1");
      } else {
        await formRef.current!.showField("State1");
      }
    },
    SetStateSingleValue: async (form: any) => {
      let formData = form.getFieldsValue();
      console.log(formData);
       
    },
    showQuickAddModal: async (form: any, label: string) => {
      if (label) {
        setIsQuickAddModalVisible((prev) => ({ ...prev, [label]: true }));
        return true;
      }
    },
   
 
    HandleQuantityChange: async (
      form: any,
      rowId: string | number,
      fieldSetKey: string
    ) => {
      // Get row-specific values
      const rowValues = form.getFieldValue([fieldSetKey, String(rowId)]);
      console.log("Row Values:", rowValues);

      // Update only the Cost field for that row
      form.setFieldValue(
        [fieldSetKey, String(rowId), "Age"],
        `${rowValues?.Title * 5}`
      );

      console.log(`Updated Cost for row ${rowId}:`, "Age");
    },
  };

  return (
  
      <ActionHandlerProvider
        rowActionHandler={rowActionHandler}
        reportActionHandler={reportActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        <InterfaceComponent
          InterfaceName={"SampleFormTest"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={113}
          Mode={"Edit"}
          ref={formRef}
        />
      
        <ModalPopup
          title=""
          open={openModalKey}
          onCancel={interfaceActionHandler["closeModal"]}
        >
          <InterfaceComponent
            InterfaceName={"statev3"}
             
            actionType={"Submit"}
            RId={0}
            Mode={"Create"}
            onSuccess={interfaceActionHandler["closeModal"]}
          />
        </ModalPopup>
      </ActionHandlerProvider>
     
  );
}
